// @owners { team: patients-team }
// eslint-disable-next-line @alto/no-pocky-import
import { toaster } from '@alto/pocky';
import { omit } from 'lodash';
import { closeModal } from '~shared/actions/modal';
// eslint-disable-next-line import/no-deprecated
import { uploadImageToS3 } from '~shared/actions/upload';
// eslint-disable-next-line import/no-deprecated
import { clearUserError, updateUser } from '~shared/actions/users';
import { DEFAULT_ERROR_ALERT_MESSAGE, DEFAULT_ERROR_ALERT_TITLE } from '~shared/constants';
import { getSelectedUser } from '~shared/features/users/selectors/getSelectedUser';
import { formatDateStringForAPI } from '~shared/helpers/date';
import { connect } from '~shared/store';
import { type ReduxStateShared } from '~shared/types';
import PersonalInfoModal, { type Props } from './PersonalInfoModal';

const mapStateToProps = (state: ReduxStateShared) => {
  const { modal } = state;
  const { modalType, show } = modal;

  const user = getSelectedUser(state);

  return {
    modalType,
    show,
    user,
  };
};

const mapDispatchToProps = {
  clearUserError,
  closeModal,
  // eslint-disable-next-line import/no-deprecated
  updateUser,
  // eslint-disable-next-line import/no-deprecated
  uploadImageToS3,
};

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  dispatchProps: typeof mapDispatchToProps,
): Props => {
  const { user, ...newStateProps } = stateProps;
  const {
    clearUserError: clearError,
    closeModal: close,
    updateUser: update,
    uploadImageToS3: uploadImage,
    ...newDispatchProps
  } = dispatchProps;

  const { id, photo_id_url } = user || {};

  return {
    ...newStateProps,
    ...newDispatchProps,
    user,
    onClose: () => {
      clearError();
      close('PERSONAL_INFO_MODAL'); // resetForm();
    },
    // @ts-expect-error TS(7006): Parameter 'data' implicitly has an 'any' type.
    onSubmit: (data) => {
      data.date_of_birth = formatDateStringForAPI(data.date_of_birth);

      // @ts-expect-error TS(7006): Parameter 'userParams' implicitly has an 'any' type.
      function perform(userParams) {
        if (!id) {
          toaster.toast({
            kind: 'danger',
            title: DEFAULT_ERROR_ALERT_TITLE,
            description: DEFAULT_ERROR_ALERT_MESSAGE,
          });

          return;
        }

        const params = omit(userParams, ['first_name', 'last_name', 'date_of_birth']);

        // eslint-disable-next-line promise/catch-or-return
        update({
          id,
          ...params,
          // @ts-expect-error TS(7031): Binding element 'success' implicitly has an 'any' type.
        }).then(({ success }) => {
          // eslint-disable-next-line promise/always-return
          if (success) {
            clearError();
            close('PERSONAL_INFO_MODAL');
          }
        });
      }

      if (data.photo_id_url && photo_id_url !== data.photo_id_url) {
        // @ts-expect-error TS(7006): Parameter 'url' implicitly has an 'any' type.
        // eslint-disable-next-line promise/catch-or-return
        uploadImage(data.photo_id_url[0], 'users').then((url) => {
          // eslint-disable-next-line promise/always-return
          if (url) {
            data.photo_id_url = url;
            perform(data);
          }
        });
      } else {
        if (data.photo_id_url) delete data.photo_id_url;
        perform(data);
      }
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PersonalInfoModal);
